import { useQuery } from "react-query";
import { getStudentSituations } from "../services/school/studentSituation";
import { PagedRequestType } from "../types/PagedResults";
import { Key_StudentSituations } from "../utils/constants";

export const useGetStudentSituationsQuery = (data: PagedRequestType, options:any= null) => {
    return useQuery(
        [Key_StudentSituations, JSON.stringify(data)],
        () => getStudentSituations(data), 
        options?{...options}:{}
    );
};
